import ReactDOM from 'react-dom/client'
import { pipe } from 'remeda'
import { NewsletterSection } from '@components/NewsletterSection/NewsletterSection'
import { withErrorBoundary, withI18next, withSuspense, withTheme } from '@hocs'
import type { NewsletterSectionData } from '@velasca/types'

export const renderNewsletterSectionApp = (
  newsletterSectionEl: HTMLElement | null,
  newsletterSectionData: NewsletterSectionData,
): void => {
  if (newsletterSectionEl && newsletterSectionData) {
    const NewsletterSectionApp = () => (
      <NewsletterSection {...newsletterSectionData} />
    )

    const NewsletterSectionAppWrapper = pipe(
      NewsletterSectionApp,
      withSuspense,
      withI18next,
      withErrorBoundary,
      withTheme,
    )

    ReactDOM.createRoot(newsletterSectionEl).render(
      <NewsletterSectionAppWrapper />,
    )
  }
}
